import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import Text from '../../../Text';
import Checkbox from '../../../Checkbox';
import Button from '../../../Button';
import Tooltip from '../../../Tooltip';
import styles from './ListSidebarBulkOperations.module.css';

const bindClasses = classNameBind.bind(styles);

const ListSidebarBulkOperations = ({
  bulkSelectionOptions,
  bulkSelectionOnSelectAll,
  bulkSelectionNumberOfSelecetedElements,
  listData,
  t,
} = {}) => {
  const numberOfSelecetedElements = bulkSelectionNumberOfSelecetedElements || listData.filter(el => el.isCheckboxSelected).length;

  let selectAllState = 'checkedPartially';

  if (numberOfSelecetedElements === 0) {
    selectAllState = 'unchecked';
  } else if (numberOfSelecetedElements === listData.length) {
    selectAllState = 'checked';
  }

  return (
    <div
      className={bindClasses('wrapper')}
      data-ppuc-id="ListSidebar.ListSidebarBulkOperations"
    >
      <div className={bindClasses('checkbox-all')}>
        <Checkbox
          name="select-all"
          id="select-all"
          dataId="ListSidebar.ListSidebarBulkOperations.SelectAllCheckbox"
          checked={selectAllState !== 'unchecked'}
          checkedMixed={selectAllState === 'checkedPartially'}
          onChange={() => { bulkSelectionOnSelectAll(selectAllState === 'unchecked'); }} // True for should select all, false for unselect all
        />
      </div>
      <div className={bindClasses('selected-number')}>
        <Text type="subdued">{t('numberOfSelectedItems', { count: numberOfSelecetedElements })}</Text>
      </div>
      {bulkSelectionOptions.map((el, index) => (
        <div className={bindClasses('action-button')} key={index}>
          <Tooltip content={el.tooltip}>
            <Button
              text={el.name}
              appearance="subdued-compact"
              onClick={el.onClick}
              disabled={el.disabled}
              minimalWidth
            />
          </Tooltip>
        </div>
      ))}
    </div>
  );
};

ListSidebarBulkOperations.defaultProps = {
  bulkSelectionOptions: [],
  bulkSelectionOnSelectAll: () => {},
  listData: [],
};

export const PureComponent = ListSidebarBulkOperations;
export default withTranslation('components')(ListSidebarBulkOperations);
